<template>
  <modal id="prolongedSickLeaveModal" v-cloak>
    <template v-if="!this.isProlongedSickLeavePeriodStarted" slot="title">Ziekte startdatum</template>
    <template v-else slot="title">Einddatum ziekte</template>
    <div slot="body">
      <div v-if="!isProlongedSickLeavePeriodStarted">
        <DateInputField class="w-50 d-inline-block" v-model="updatedDates.startDate" labelText="startDatum"/>
      </div>
      <div v-else>
        <DateInputField class="w-50 d-inline-block" v-model="updatedDates.endDate" labelText="einddatum"/>
      </div>
    </div>
    <div slot="footer">
      <button class="btn-basic btn-outline-pulse-dark mr-2" @click="closeModal">Annuleren</button>
      <button class="btn-basic btn-outline-pulse mr-2" @click="savePeriod">Opslaan</button>
    </div>
  </modal>
</template>
<script>

import DateInputField from "@/components/inputFields/DateInputField";

export default {

  name: 'App',
  components: {
    DateInputField,
  },
  props: ["isProlongedSickLeavePeriodStarted"],
  data() {
    return {
      updatedDates: {
        startDate: "",
        endDate: ""
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    savePeriod() {
      if (!this.isProlongedSickLeavePeriodStarted) {
        this.$emit('start-period', this.updatedDates.startDate);
      } else {
        this.$emit('end-period', this.updatedDates.endDate);
      }
      this.$emit('close');
    },
  },
};
</script>